import * as React from 'react';

import UserMenu from './UserMenu';

/* NOTE: requires user log in */
class UserMenuVisual extends React.Component {
    public render() {
        return (
            <div style={{ position: "relative", marginLeft: "200px", width: "1px", height: "300px", fontFamily: "Lato, sans-serif" }}>
                <UserMenu onSignOutRequested={this.voidFn} />
            </div>
        );
    }

    private voidFn = () => {
        /* this is not empty */
    };
}

export default UserMenuVisual;


// WEBPACK FOOTER //
// ./src/App/Blocks/UserMenu.visual.tsx